// src/components/leadsComponents/AddEmailForm.js
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addEmail } from '../../store/thunks/leadsActions';

export default function AddEmailForm({ leadId }) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [title, setTitle] = useState('');
  const [address, setAddress] = useState('');
  const dispatch = useDispatch();

  const handleAdd = () => {
    if (!address) return;
    // const name = [firstName, lastName].filter(Boolean).join(' ');
    dispatch(addEmail({
      leadId,
      address 
    }))
    .unwrap()
    .catch(console.error);
    // clear
    setFirstName('');
    setLastName('');
    setTitle('');
    setAddress('');
  };

  return (
    <div className="mt-2 space-y-2">
      <div className="flex gap-2">
        <input
          type="email"
          placeholder="Email address"
          className="flex-1 p-2 border rounded-[12px] text-[#1F2937]"
          value={address}
          onChange={e => setAddress(e.target.value)}
        />
        <button
          className="px-3 py-2 rounded-[12px] bg-[#2563EB] text-[#FFFFFF]"
          onClick={handleAdd}
        >
          Add
        </button>
      </div>
    </div>
  );
}
